import { render, staticRenderFns } from "./MPrice.vue?vue&type=template&id=52e9f8bc&scoped=true"
import script from "./MPrice.vue?vue&type=script&lang=js"
export * from "./MPrice.vue?vue&type=script&lang=js"
import style0 from "./MPrice.vue?vue&type=style&index=0&id=52e9f8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9f8bc",
  null
  
)

export default component.exports